module.exports = __webpack_public_path__ + "img/usecase03.2e5b5fd0.png";